import { useDispatch } from 'react-redux';

import { useLandingInitQuery } from 'hooks/queries/useLandingInitQuery';
import {
  setCsrfToken,
  setIsLandingAdditionalPriceEnabled,
  setIsLandingValidationSkipEnabled,
} from 'store/common/commonSlice';

import { useUserId } from './useUserId';

export const useLandingInit = (isInitialized: boolean) => {
  const dispatch = useDispatch();

  const { userId } = useUserId();

  const { isLoading, isSuccess, isError } = useLandingInitQuery(userId, {
    enabled: isInitialized,
    onError: () => {
      dispatch(setIsLandingValidationSkipEnabled(false));
    },
    onSuccess: (data) => {
      dispatch(
        setIsLandingValidationSkipEnabled(
          data.landing_validation_split || false
        )
      );
      dispatch(setIsLandingAdditionalPriceEnabled(data.is_additional_price));
      dispatch(setCsrfToken(data.csrf_token));
    },
  });

  return {
    isLandingInitLoading: isLoading,
    isLandingInitLoaded: isSuccess || isError,
  };
};
